function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5001 3C9.49297 3 3 9.65607 3 17.8671C3 24.4358 7.15472 30.0086 12.9161 31.9744C13.6407 32.1121 13.9068 31.6519 13.9068 31.2593C13.9068 30.9047 13.8933 29.7336 13.8871 28.4913C9.85315 29.3907 9.00194 26.7372 9.00194 26.7372C8.34234 25.0188 7.39196 24.5618 7.39196 24.5618C6.07636 23.6391 7.49113 23.6581 7.49113 23.6581C8.94719 23.7629 9.71388 25.1901 9.71388 25.1901C11.0071 27.463 13.106 26.8059 13.9334 26.426C14.0636 25.4651 14.4394 24.8092 14.854 24.438C11.6334 24.0621 8.24773 22.7873 8.24773 17.0906C8.24773 15.4675 8.81417 14.1412 9.74173 13.1001C9.59118 12.7256 9.09486 11.2135 9.8822 9.16566C9.8822 9.16566 11.0998 8.76608 13.8708 10.6896C15.0274 10.3602 16.2678 10.195 17.5001 10.1893C18.7324 10.195 19.9738 10.3602 21.1326 10.6896C23.9002 8.76608 25.1161 9.16566 25.1161 9.16566C25.9054 11.2135 25.4088 12.7256 25.2583 13.1001C26.188 14.1412 26.7506 15.4675 26.7506 17.0906C26.7506 22.8008 23.3585 24.0581 20.1296 24.4262C20.6497 24.8875 21.1131 25.7923 21.1131 27.1793C21.1131 29.1686 21.0963 30.7696 21.0963 31.2593C21.0963 31.6549 21.3573 32.1185 22.0923 31.9725C27.8506 30.0044 32 24.4336 32 17.8671C32 9.65607 25.508 3 17.5001 3Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.53468 24.2439C8.50281 24.317 8.38969 24.339 8.28663 24.2887C8.18165 24.2407 8.12269 24.141 8.15673 24.0677C8.18788 23.9923 8.30125 23.9714 8.40598 24.0218C8.5112 24.0698 8.57111 24.1705 8.53468 24.2439Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.12092 24.9089C9.05189 24.974 8.91696 24.9437 8.8254 24.8409C8.73074 24.7382 8.713 24.601 8.78298 24.5349C8.85417 24.4699 8.98502 24.5003 9.07993 24.603C9.1746 24.7068 9.19306 24.8431 9.12092 24.9089Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.69157 25.7567C9.60289 25.8193 9.45789 25.7606 9.36826 25.6297C9.27958 25.4988 9.27958 25.3418 9.37017 25.2789C9.46005 25.216 9.60289 25.2726 9.69373 25.4025C9.78217 25.5356 9.78217 25.6926 9.69157 25.7567Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4734 26.5758C10.394 26.6647 10.2251 26.6408 10.1014 26.5194C9.97486 26.4007 9.93963 26.2323 10.0192 26.1433C10.0995 26.0541 10.2694 26.0792 10.394 26.1996C10.5196 26.3181 10.558 26.4878 10.4734 26.5758Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5519 27.0513C11.5169 27.1666 11.3542 27.219 11.1902 27.17C11.0265 27.1196 10.9194 26.9845 10.9525 26.868C10.9865 26.752 11.15 26.6974 11.3151 26.7498C11.4785 26.8 11.5859 26.9341 11.5519 27.0513Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7363 27.1396C12.7404 27.261 12.6014 27.3616 12.4293 27.3638C12.2563 27.3677 12.1163 27.2695 12.1144 27.1501C12.1144 27.0274 12.2503 26.9277 12.4233 26.9248C12.5954 26.9214 12.7363 27.0189 12.7363 27.1396Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8386 26.9487C13.8592 27.0672 13.7396 27.1888 13.5687 27.2212C13.4007 27.2524 13.2451 27.1793 13.2238 27.0618C13.203 26.9404 13.3247 26.8188 13.4925 26.7873C13.6636 26.7571 13.8168 26.8283 13.8386 26.9487Z",
  fill: "white"
});

var SvgGithub = function SvgGithub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Github.bd34462c.svg";
export { ForwardRef as ReactComponent };